export enum ActivationStatus {
  ACTIVATE_SIM = 'activate_sim', // Activate SIM
  ACTIVATION_REQUESTED = 'activation_requested', // Activation requested
  AWAITING_ACTIVATION = 'activation_pending', // Awaiting activation
  ACTIVATION_FAILED = 'activation_failed', // Activation failed
}

export enum OwnerPreActivationStatus {
  ACTIVATE_SIM = 'activate_sim',
  AWAITING_ACTIVATION = 'activation_pending',
  ACTIVATION_FAILED = 'activation_failed',
}

export enum SignUpStatus {
  SETUP = 'sign_up_setup', // Setup
  INVITATION_SENT = 'sign_up_pending', // Invitation sent
  INVITATION_ACCEPTED = 'sign_up_completed', // Invitation accepted
}

export enum MemberDashboardStatus {
  PAUSE_SCHEDULED = 'pause_scheduled',
  ACTIVE = 'active',
  CLOSING = 'account_closing',
}

export enum PostActivationStatus {
  PAUSE_SCHEDULED = 'pause_scheduled',
  PAUSED = 'paused',
  ACTIVE = 'active',
  PLAN_CHANGE_PENDING = 'plan_change_pending',
  PLAN_CHANGE_PENDING_TO_SOLO = 'plan_change_pending_to_solo',
  EXPIRED = 'expired',
  CLOSING = 'account_closing',
  CLOSED = 'account_closed',
}

export enum StatusAllowedForLinkToProfile {
  PAUSE_SCHEDULED = 'pause_scheduled',
  PAUSED = 'paused',
  ACTIVE = 'active',
  CLOSING = 'account_closing',
}

export type Status =
  | ActivationStatus
  | SignUpStatus
  | PostActivationStatus
  | OwnerPreActivationStatus

export type Member = {
  customer_id: number
  customer_ref: string
  group_member_id: number
  is_owner: boolean
  is_member: boolean
  first_name: string
  last_name: string
  nickname: 'device' | 'under_16' | null
  email: string | null
  msisdn: string
  invitation_sent_at?: string
  member_sorting_order: number
  status: Status
  join_date?: string
  leave_date?: string
  customer_closure?: string
}

export enum StatusColor {
  GREY = 'grey',
  GREEN = 'green',
  BLUE = 'blue',
  ORANGE = 'orange',
  YELLOW = 'yellow',
}

export interface PortInPoolItem extends FamilyPortInDetails {
  id: number | string
}

export interface FamilyPortInDetails {
  name: string
  msisdn: string
  code: string
  switch_date?: string
  code_expiration: string
}

export interface FamilyPortInPool {
  hasFetched: boolean
  isFetching: boolean
  data: PortInPoolItem[] | null
  newNumbers: PortInPoolItem[]
  error: string | null
}

export interface FamilySoloPortInPool {
  hasFetched: boolean
  isFetching: boolean
  data: PortInPoolItem | null
  newNumbers: PortInPoolItem | null
  error: string | null
}

export type PortInValidatePoolItemPayload = {
  msisdn: string
  pac_code: string
  requested_switch_date?: string
}

export type PortInPoolItemValidation = {
  switch_date: string
  code_expiry_date: string
}

export interface ShippingAddress {
  recipientName: string
  line1: string
  line2: string
  city: string
  state: string
  countryCode: string
  postalCode: string
}

export interface OrderFormData {
  search: boolean
  manual: boolean
  push_notification_marketing: boolean
  firstName: string
  lastName: string
  email: string
  password: string
  dob: string
  shippingAddress: ShippingAddress
  email_marketing: boolean
  sms_marketing: boolean
  post_marketing?: boolean
  third_party_marketing: boolean
  terms_and_conditions: boolean
  /**
   * this is radio button with string values
   * we convert it to boolean when we submit the order
   * */
  profiled_marketing?: string
}

export interface PreContractGeneratorArguments {
  planId: string
  monthlyPayments: boolean
  voucherCode: string | null
  portInNumber?: string
  portInCode?: string
  membersNumber?: number
  simForOwner?: boolean | undefined
  journeyType?: string
  email?: string | null
}

export enum GroupSummaryErrors {
  NOT_ULFP_CUSTOMER = 'Not a ULFP customer',
  UNKNOWN = 'Unknown error',
}
